import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=cf53e5f2&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=cf53e5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf53e5f2",
  null
  
)

export default component.exports